<div class="pt-100 unauth-container pb-50">
  <img src="/assets/images/unauthorized.svg">
  <div class="fw-600 fs-24 mat-subtitle-2 mt-32"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
</div>
